module.exports = __webpack_public_path__ + "static/media/team_2.f03f0461.png";